import { r as registerInstance, f as forceUpdate, h, H as Host } from './index-ih07wrgW.js';
import { i as i18nProvider, l as loadTranslations } from './loadTranslations-lQVeesvD.js';

const CreateServiceCaseModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Enable file upload in the form
         */
        this.fileUpload = false;
        /**
         * data that should be prefilled in the form
         * @optional
         */
        this.prefillData = null;
        /**
         * The locale to use for translations and the phone input
         */
        this.locale = "en-US";
        /**
         * Environment string to decide which endpoints to use
         */
        this.env = "prod";
        /**
         * use onprem Public API instead of azure
         * @deprecated only used until April 2025
         */
        this.legacyApi = false;
        /**
         * open modal automatically
         */
        this.open = false;
        /** URL to be opened when the modal is closed */
        this.reloadUrl = "";
        /**
         * origin application of the request, e.g. 'oseon' or 'MyTRUMPF'
         */
        this.origin = "";
        this.submitted = false;
        this.handleModalClose = () => {
            if (this.reloadUrl && this.reloadUrl.length > 0) {
                window.location.href = this.reloadUrl;
                return;
            }
            window.location.reload();
        };
    }
    handleServiceCaseSuccess() {
        this.modal.triggerClose();
    }
    handleServiceCaseCancel() {
        this.modal.triggerClose();
    }
    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    componentDidLoad() {
        if (this.open) {
            this.modal.triggerOpen();
        }
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    handleServiceCaseShowSuccess() {
        this.submitted = true;
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        return (h(Host, { key: 'e7a407f98768ab00615d41c3ebfee1e9e65752c8' }, h("ux-modal", { key: '31b20f6f8e617ad3168b53db6878fbfd25641a49', onUxModalClose: () => this.handleModalClose(), name: this.modalName, ref: (el) => (this.modal = el) }, h("ux-modal-content", { key: '5bd39e22aaeb7e36ab62e98ffb5308ce4dc3b02c' }, h("mf-create-service-case", { key: '3e2f802b09097ff69d800447a4648f25ec7cc1ae', fileUpload: this.fileUpload, prefillData: this.prefillData, multipleSteps: true, locale: this.locale, env: this.env, legacyApi: this.legacyApi, origin: this.origin }, h("slot", { key: '6f17bffbb7ca11384cca9e3c039a429c4035e493', name: "connector" }))), this.submitted && (h("ux-modal-footer", { key: 'dd973b65a3faeacd8ed6750f0d483e53e02668a4' }, h("ux-button", { key: 'b8697f418e4f092546b474ae13dd8366078c3a34', variant: "primary", onClick: () => {
                this.modal.triggerClose();
            } }, t("button.ok")))))));
    }
    static get watchers() { return {
        "locale": ["onLocaleChange"]
    }; }
};

export { CreateServiceCaseModal as mf_create_service_case_modal };
//# sourceMappingURL=mf-create-service-case-modal.entry.js.map

//# sourceMappingURL=mf-create-service-case-modal.entry.js.map